var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriteOutlineSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14072_4135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4945 2.94655C21.4023 1.96499 20.0007 1.45781 18.5851 1.49999C16.8278 1.49999 15.054 2.22187 13.757 3.56155L12.8335 4.51171L11.9101 3.56155C10.6117 2.22187 8.83978 1.49999 7.08197 1.49999C5.66634 1.49999 4.26618 1.96546 3.13228 2.94655C0.219462 5.46796 0.0736803 9.96374 2.69962 12.6778L11.7559 22.0387C12.0554 22.3453 12.4398 22.5 12.8288 22.5C13.2194 22.5 13.6112 22.3468 13.9074 22.0404L22.959 12.6795C25.5929 9.96092 25.4476 5.46561 22.4945 2.94655ZM21.346 11.114L12.8335 19.9172L4.31821 11.114C2.80696 9.55311 2.44884 6.47343 4.60509 4.64765C6.4754 3.02859 9.039 3.82733 10.2957 5.12437L12.8349 7.74561L15.3737 5.12437C16.6121 3.84608 19.1828 3.02015 21.0643 4.64765C23.1976 6.49686 22.8882 9.5203 21.346 11.114Z",
    fill: "#E25297"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14072_4135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.833496)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteOutlineSvg);
export default __webpack_public_path__ + "static/media/FavoriteOutlineSvg.70e4040d2cf8cc7fa20351edd33ad36c.svg";
export { ForwardRef as ReactComponent };